
import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';

class LanguageManager {

    private static instance: LanguageManager;
    private languageCode = 'en';
    private translations: any = {};
    private availableLanguages: string[] = ['en', 'es', 'zh', 'pt'];

    
    constructor() {
        if (!LanguageManager.instance) {

            this.getLanguageCode().then(languageCode => {

                if (!this.availableLanguages.includes(languageCode)) {
                    languageCode = 'en';
                }

                this.languageCode = languageCode;
                this.loadTranslations();
                LanguageManager.instance = this;
                console.log('languageCode:', this.languageCode);
                return LanguageManager.instance;
            });

        } else {
            return LanguageManager.instance;
        }  
    }

    private async loadTranslations() {
        try {
            const response = await fetch(`./assets/translations/${this.languageCode}.json`);
            if (!response.ok) {
                throw new Error(`Load Translations Error to ${this.languageCode}`);
            }
            this.translations = await response.json();
        } catch (error) {
            console.error(`Load Translations Error to ${this.languageCode}:`, error);
            this.translations = {};
        }
    }

    public key(key: string):string {
        return this.translations[key] || key;
    }

    private async getLanguageCode() {
        let languageCode = 'en';
        try {
            if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
                const LanguageTag = await Device.getLanguageCode();
                languageCode = LanguageTag.value;
            } else {
                languageCode = navigator.language.split('-')[0];
            }
        } catch (error) {
            console.error('Get Language Code Error:', error);
        }

        return languageCode;
    }
}

// Singleton instance
const translate = new LanguageManager();
export default translate;